import Field from "@/components/form/Field.tsx";
import {Input} from "@/components/ui/input.tsx";
import {Label} from "@/components/ui/label.tsx";
import {cn} from "@/lib/utils.ts";

export default function TextField(props: TextFieldProps) {
    const className = cn("w-full", props.className, props.disabled ? "text-gray-400" : "");
    return <Field defaultValue={props.defaultValue} name={props.name} validate={props.validate}>
        {(field) => {
            return (
                <>
                    <Label className={className}>{props.label}
                        <Input className={className} {...props} value={field.value} aria-invalid={!!field.error}
                               onChange={(e) => field.onChange(e.target.value)}
                               onBlur={field.onBlur}/>
                        <div className={"h-4"}>
                            <span className={"text-destructive text-sm"}>{field.error ? field.error.text : ""}</span>
                        </div>
                    </Label>
                </>)
        }}
    </Field>
}